import { WorkspaceTools } from 'map-3d/shared/map-3d-tools/enums';
import { ToolboxShortcutAction } from './enums';
import type { ToolboxShortcutDefinition } from './types';

export const DRAWING_INSTRUCTION: Partial<Record<WorkspaceTools, string>> = {
  [WorkspaceTools.PolygonTool]:
    'Right-click or click the first vertex to complete the polygon, or press Esc to discard.',
  [WorkspaceTools.LineTool]:
    'Right-click to complete the line, or press Esc to discard.',
  [WorkspaceTools.SelectFeatureTool]:
    'Click a feature on the map to select it.',
};

/*
 * Tools whose instruction explains how to finish a geometry, so it is only worth showing once the user has actually started one.
 */
export const DRAW_COMPLETION_INSTRUCTION_TOOLS = [
  WorkspaceTools.PolygonTool,
  WorkspaceTools.LineTool,
];

export const EDITING_HANDLES_HIDDEN_INSTRUCTION =
  'Zoom in to start editing the selected feature.';

export const DESELECT_FEATURE_INSTRUCTION =
  'Ctrl/⌘ + click a selected feature to deselect it.';

export const REMOVE_VERTEX_INSTRUCTION = 'Right-click a vertex to remove it.';

export const TOOLBOX_SHORTCUTS: Record<
  ToolboxShortcutAction,
  ToolboxShortcutDefinition
> = {
  [ToolboxShortcutAction.SelectTool]: {
    keys: ['v'],
    label: 'Select',
    keyHint: 'V',
  },
  [ToolboxShortcutAction.PointTool]: {
    keys: ['p'],
    label: 'Point',
    keyHint: 'P',
  },
  [ToolboxShortcutAction.LineTool]: {
    keys: ['l'],
    label: 'Line',
    keyHint: 'L',
  },
  [ToolboxShortcutAction.PolygonTool]: {
    keys: ['o'],
    label: 'Polygon',
    keyHint: 'O',
  },
  [ToolboxShortcutAction.TextboxTool]: {
    keys: ['t'],
    label: 'Text',
    keyHint: 'T',
  },
  [ToolboxShortcutAction.Delete]: {
    // Mac keyboards send Backspace from the key labelled Delete.
    keys: ['Delete', 'Backspace'],
    label: 'Delete',
    keyHint: 'Del',
  },
  [ToolboxShortcutAction.Save]: {
    keys: ['s'],
    withCommand: true,
    label: 'Save',
    keyHint: 'Ctrl/⌘ + S',
  },
  [ToolboxShortcutAction.Exit]: {
    keys: ['Escape'],
    withCommand: true,
    label: 'Exit',
    keyHint: 'Ctrl/⌘ + Esc',
  },
};
